import { render, staticRenderFns } from "./MTableCellMetricPerformance.vue?vue&type=template&id=1b48be6e"
import script from "./MTableCellMetricPerformance.vue?vue&type=script&lang=js"
export * from "./MTableCellMetricPerformance.vue?vue&type=script&lang=js"
import style0 from "./MTableCellMetricPerformance.vue?vue&type=style&index=0&id=1b48be6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports